"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignInService = void 0;
class SignInService {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    getApiV1SignInModule({ moduleId, authorization = 'Bearer <token>', onFailureRedirect, locale, }) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/SignIn/module/{moduleId}',
            path: {
                moduleId: moduleId,
            },
            headers: {
                Authorization: authorization,
            },
            query: {
                onFailureRedirect: onFailureRedirect,
                locale: locale,
            },
            errors: {
                400: `Bad Request
                Not Found
                Internal Server Error
                `,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Oops! Internal server error, try later.`,
            },
        });
    }
}
exports.SignInService = SignInService;
